import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Volume, Volume1, Volume2, VolumeX } from "lucide-react";
import { cn } from "@/lib/utils";
import { useCaregiverTranslation } from "@/hooks/useCaregiverTranslation";
import { MainLayout } from "@/components/layout/MainLayout";

export default function VolumeControl() {
  const navigate = useNavigate();
  const { t, dir } = useCaregiverTranslation();
  
  const [currentVolume, setCurrentVolume] = useState(() => {
    const saved = localStorage.getItem("ayuni_volume");
    return saved ? parseInt(saved) : 3;
  });

  const volumeLevels = [
    { value: 1, labelKey: "veryLow" as const, icon: VolumeX },
    { value: 2, labelKey: "low" as const, icon: Volume },
    { value: 3, labelKey: "mediumVol" as const, icon: Volume1 },
    { value: 4, labelKey: "high" as const, icon: Volume2 },
    { value: 5, labelKey: "veryHigh" as const, icon: Volume2 },
  ];

  const handleVolumeChange = (value: number) => {
    setCurrentVolume(value);
    localStorage.setItem("ayuni_volume", value.toString());
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <MainLayout onBack={handleBack}>
      <div className="flex-1 flex flex-col min-h-0" dir={dir}>
        {/* Header - matches Settings page style */}
        <header className="flex-shrink-0 flex items-center gap-3 px-6 py-4 border-b border-primary bg-card/50">
          <Volume2 className="w-5 h-5 text-primary" />
          <h1 className="text-2xl font-bold">{t("volumeTitle")}</h1>
        </header>

        <div className="flex-1 min-h-0 overflow-y-auto p-6">
          <div className="max-w-md w-full mx-auto p-4 rounded-2xl bg-card border border-primary space-y-2">
            <div className="space-y-2">
              {volumeLevels.map((item, idx) => {
                const Icon = item.icon;
                const isSelected = item.value === currentVolume;

                return (
                  <button
                    key={item.value}
                    onClick={() => handleVolumeChange(item.value)}
                    data-scan-item
                    className={cn(
                      "w-full flex items-center gap-3 p-3 rounded-xl transition-all",
                      isSelected
                        ? "bg-primary text-primary-foreground"
                        : "bg-muted hover:bg-muted/80 text-foreground"
                    )}
                  >
                    <Icon className="w-5 h-5" />
                    <span className="text-base font-medium">{t(item.labelKey)}</span>
                    {isSelected && (
                      <div className={cn("w-4 h-4 bg-primary-foreground rounded-full", dir === "rtl" ? "mr-auto" : "ml-auto")} />
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
